import { Aperture } from "lucide-react";

import { cn } from "@/lib/cn";

export function Brand({
  withText = true,
  className,
}: {
  withText?: boolean;
  className?: string;
}) {
  return (
    <span className={cn("flex items-center gap-2", className)}>
      <span className="grid h-7 w-7 place-items-center rounded-lg bg-indigo-600 text-white shadow-sm">
        <Aperture className="h-4 w-4" />
      </span>
      {withText && (
        <span className="text-[15px] font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">
          ListReel
        </span>
      )}
    </span>
  );
}
